import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

/**
 * Checks if a shipping address has all required fields filled.
 *
 * @param address - The shipping address to validate
 * @returns `true` if the address is complete, `false` otherwise
 */
export function isShippingAddressComplete(
  address: ApiSpecs['/bm/cart']['GET']['response']['addressList']['deliver'],
): boolean {
  return (
    !isEmpty(address) &&
    !isEmpty(`${address.firstName} ${address.lastName}`.trim()) &&
    !isEmpty(address.street?.trim()) &&
    !isEmpty(address.postalCode?.trim()) &&
    !isEmpty(address.city?.trim()) &&
    !isEmpty(address.country) &&
    !isEmpty(address.countryDialInCode) &&
    !isEmpty(address.phone)
  )
}

/**
 * Checks if a billing address has all required fields filled.
 *
 * @param address - The billing address to validate
 * @returns `true` if the address is complete, `false` otherwise
 */
export function isBillingAddressComplete(
  address: ApiSpecs['/bm/cart']['GET']['response']['addressList']['bill'],
): boolean {
  return (
    !isEmpty(address) &&
    !isEmpty(`${address.firstName} ${address.lastName}`.trim()) &&
    !isEmpty(address.street?.trim()) &&
    !isEmpty(address.postalCode?.trim()) &&
    !isEmpty(address.city?.trim()) &&
    !isEmpty(address.country)
  )
}

/**
 * Checks if a collection point address has all required fields filled.
 *
 * @param address - The collection point address to validate
 * @returns `true` if the address is complete, `false` otherwise
 */
export function isCollectionPointAddressComplete(
  address: ApiSpecs['/bm/cart']['GET']['response']['addressList']['deliverCollectionPoint'],
): boolean {
  return (
    !isEmpty(address) &&
    !isEmpty(address.firstName) &&
    !isEmpty(address.lastName) &&
    !isEmpty(address.countryDialInCode) &&
    !isEmpty(address.phone)
  )
}
